



























import Vue from "vue";
import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import * as types from "@/store/constants/types";
import { getAppVersion, isIos } from "@/utils/lodash";
import { versionGreaterThan, isSupportLocalFiles } from "@/utils/judgeVersion";
import Lottie from "./VipLottie.vue";
import * as lottieVipData from "@/assets/lotties/vip-video/vip_store.json";

@Component({
  components: {
    Lottie
  }
})
export default class VipVideo extends Vue {
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Action(types.FETCH_VIDEO_URL_BY_DICT)
  private fetchVideoUrlByDict: any;

  private showVideo = true;

  private videoUrl: any = "";

  get coverImage() {
    return require("@/assets/icons-file/store_vip/new_vip_face0.jpg");
  }

  // get videoUrl() {
  //   return this.settingData && this.settingData.vip_video_url
  //     ? this.settingData.vip_video_url
  //     : "https://cdn.soupep.com/video/vip_video_2.mp4";
  // }

  get isAutoPlaySupported() {
    return isSupportLocalFiles();
  }

  get lottieOptions() {
    return {
      animationData: lottieVipData,
      loop: true,
      autoplay: true
    };
  }

  private playVideo() {
    if (this.$refs.player) {
      (this.$refs.player as any).play();
    }
  }

  private videoPaused() {
    return (this.$refs.player as any).paused;
  }

  private handleAnimation() {}

  private initData() {
    if (this.$refs.player && this.videoPaused()) {
      this.playVideo();
    } else {
      this.showVideo = true;
    }
  }

  private destroyed() {
    AppLifeCycle.removeListener("vip_video_tab");
    AppLifeCycle.removeGoBackListener("vip_video_tab");
    this.showVideo = false;
  }

  private activated() {
    this.initData();
  }

  private deactivated() {
    this.showVideo = false;
  }

  private mounted() {
    this.initData();
  }

  private async created() {
    AppLifeCycle.addListener({
      key: "vip_video_tab",
      fn: async () => {
        this.showVideo = true;
      }
    });
    AppLifeCycle.addGoBackListener({
      key: "vip_video_tab",
      fn: async () => {
        this.showVideo = false;
      }
    });
    const video_dict =
      this.settingData &&
      this.settingData.vip_video_files &&
      this.settingData.vip_video_files.vip_video_one;
    this.videoUrl = video_dict
      ? await this.fetchVideoUrlByDict(video_dict)
      : await this.fetchVideoUrlByDict({
          name: "vip_video_one.mp4",
          url: "https://cdn.soupep.com/video/vip_video_2.mp4"
        });
  }
}
